import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import QuickPostOptions from "%/dynamic-component-editor/bundles/quick-post-options";
import PlaceholderText from "%/dynamic-component-editor/options/placeholder-text";
import QuickPostPrompt from "%/dynamic-component-editor/options/quick-post-prompt";
import QuickPostShowCharacterCount from "%/dynamic-component-editor/options/quick-post-show-character-count";
import QuickPostSurface from "%/dynamic-component-editor/options/quick-post-surface";
import QuickPostImageShape from "%/dynamic-component-editor/options/quick-post-image-shape";

export const QuickPostElementMixin = {
  extends: DynamicElementMixin,
  optionBundles: [QuickPostOptions],
  data() {
    return {
      PlaceholderText,
      QuickPostPrompt,
      QuickPostShowCharacterCount,
      QuickPostSurface,
      QuickPostImageShape,
    };
  },
  methods: {
  },
};
